import { config } from "../../config"

const GetLocationMarker = () => {
  return (
    <svg className={`${config.namespace}-location-link-marker`} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 3.5L3 11.03V12.01L9.84 14.66L12.48 21.5H13.46L21 3.5Z" fill="currentColo"/>
    </svg>
  )
}

export default GetLocationMarker
